export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR';
export const AUTH_LOGOUT_USER = 'AUTH_LOGOUT_USER';
export const AUTH_LOAD_USER = 'AUTH_LOAD_USER';
export const AUTH_SET_MESSAGES = 'AUTH_SET_MESSAGES';
